import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);
// const homepages = () => import("../views/homepages");
const levelStep = () => import("../views/levelStep");
const shortcutsStep = () => import("../views/shortcutsStep");
const fruit = () => import("../views/stashRouter/fruit.vue");
const fruitCanvas = () => import("../StyleText/FruitCanvas.vue");
const sentence = () => import("../views/stashRouter/sentence.vue");
const word = () => import("../views/stashRouter/word.vue");
const scroll = () => import("../views/stashRouter/scroll.vue");
const shot = () => import("../views/stashRouter/shot.vue");
let router = new Router({
  mode: "history",
  base: "/tools/keyboard",
  scrollBehavior(to, from, savedPosition) {
    // ...
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  },
  routes: [
    {
      name: "homepages",
      path: "/",
      // alias: "/",
      redirect: "/list",
      // redirect: "/finger/1?keyboard_id=2",
      // component: homepages,
    },
    {
      name: "fruit",
      path: "/fruit",
      component: fruit,
    },
    {
      name: "fruitCanvas",
      path: "/fruitCanvas",
      component: fruitCanvas,
    },
    {
      name: "sentence",
      path: "/sentence",
      component: sentence,
    },
    {
      name: "word",
      path: "/word",
      component: word,
    },
    {
      name: "scroll",
      path: "/scroll",
      component: scroll,
    },
    {
      name: "shot",
      path: "/shot",
      component: shot,
    },
    {
      name: "levelList",
      path: "/list",
      component: () => import("../views/level/list"),
    },
    {
      name: "levelVideo",
      path: "/video/:id",
      component: () => import("../views/level/video"),
    },
    {
      name: "levelKeyboard",
      path: "/finger/:id",
      component: () => import("../views/level/finger"),
    },
    {
      name: "level",
      path: "/level/:step",
      component: levelStep,
    },
    {
      name: "level",
      path: "/shortcuts/:step",
      component: shortcutsStep,
    },
    {
      name: "game",
      path: "/game",
      component: () => import("../views/keyboardGame"),
    },
  ],
});
export default router;
